"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const createIconsMap_1 = require("./createIconsMap");
exports.EvaIconsPack = {
    name: 'eva',
    icons: createIconsMap_1.createIconsMap(),
};
//# sourceMappingURL=index.js.map